import type { TypePolicies } from '@apollo/client';

/**
 * Role fields `name`, `description`, and `genericDescription` accept an optional
 * `locale` argument for i18n. Using `keyArgs: ['locale']` tells Apollo to include
 * the locale in the cache key — so `name:EN_US` and `name:JA_JP` are stored
 * separately. This ensures locale switches don't serve stale translations.
 *
 * Fragment reads that access these fields must pass `variables: { locale }` to
 * resolve the correct cache entry (see useReadMembershipFragment.ts).
 */
export const typePolicies: TypePolicies = {
  Role: {
    fields: {
      name: { keyArgs: ['locale'] },
      description: { keyArgs: ['locale'] },
      genericDescription: { keyArgs: ['locale'] },
    },
  },
};
